import { useState, useEffect, useCallback } from 'react';
import { listReportesVisita } from 'api/reporteVisita';

// Hook de listado paginado de reportes de visita. Análogo al patrón de
// paginación server-side del resto del admin ({rows,total,limit,offset}).
export default function useReporteVisitaList(initialFilters = {}) {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const pageSize = 25;
  const [search, setSearch] = useState('');
  const [filters, setFilters] = useState(initialFilters);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const data = await listReportesVisita({
        ...filters,
        search: search || undefined,
        limit: pageSize,
        offset: (page - 1) * pageSize,
      });
      setRows(Array.isArray(data?.rows) ? data.rows : []);
      setTotal(data?.total || 0);
    } catch {
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [filters, search, page]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    rows,
    total,
    loading,
    page,
    setPage,
    pageSize,
    search,
    setSearch,
    filters,
    setFilters,
    refresh,
  };
}
